/**
 * Fire gtag events
 */
export default function gtagevent(...params) {
  if (typeof window.gtag === 'undefined') return null;

  return window.gtag?.(...params);
}
